import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormRendererPage } from '@/pages/forms/public/FormRendererPage';
import { APP_LANGUAGES } from '@/stores/global.store';

const searchSchema = z.object({
	// TanStack Router parses ?embed=false as boolean false (not string "false"),
	// so accept both boolean and string forms. Keep undefined as undefined so
	// TanStack Router doesn't write ?embed=false back to the URL when absent.
	embed: z
		.union([z.boolean(), z.enum(['true', 'false'])])
		.optional()
		.transform((v) => (v === undefined ? undefined : v === true || v === 'true')),
	lang: z.enum(APP_LANGUAGES).optional(),
});

export const Route = createFileRoute('/forms/$slug')({
	validateSearch: searchSchema,
	component: FormRendererPage,
});
